import {AnimatedText} from '#component/base';
import {Transition} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../StorySteps.types';

import * as css from './Step2.css';

export const Step2 = ({show}: StepProps) => (
  <Transition className={sprinkles({position: 'absolute', inset: 0})} show={show}>
    <AnimatedText className={css.discoverText} color="white" textAlign="center" variant="heading2">
      Here’s what we discovered
    </AnimatedText>

    <AnimatedText className={css.ageText} color="white" textAlign="center" variant="heading3">
      Your TallyAge™ is…
    </AnimatedText>
  </Transition>
);
